import { FiMap } from 'react-icons/fi';
import { FiCoffee, FiMail, FiShare2 } from 'react-icons/fi';
import { FaPaintBrush } from 'react-icons/fa';
import { BsMegaphone } from 'react-icons/bs';
import { LuPickaxe } from 'react-icons/lu';


export const gnomes = [
  {
    name: 'Doug',
    slug: 'doug',
    role: 'Leads',
    description: 'Generates targeting blueprints and identifies ideal customer profiles for your clients.',
    longDescription: 'Doug is the audience strategist. He analyzes market data to identify the most profitable customer segments and builds comprehensive ideal customer profiles for your clients. He provides the strategic targeting data needed before any outreach begins.',
    color: 'black',
    bgColorClass: 'bg-charcoal-900',
    icon: LuPickaxe,
    image: '/Doug.webp',
    action: 'Identified 100 new prospects',
    time: '6:00 AM',
    faqs: [
      {
        question: "Where does Doug find these leads?",
        answer: "Doug aggregates data from over 50 public and proprietary sources, including LinkedIn, Crunchbase, company websites, and news outlets. He cross-references this data to build comprehensive profiles."
      },
      {
        question: "Are the email addresses verified?",
        answer: "Yes. Doug performs a real-time SMTP handshake (without sending an email) to verify that the mailbox exists and is accepting mail, reducing your bounce rate significantly."
      },
      {
        question: "Can I export Doug's findings to my CRM?",
        answer: "Absolutely. Doug integrates natively with HubSpot, Salesforce, and Pipedrive. You can also export lists as CSV files for use in other tools."
      }
    ]
  },
  {
    name: 'Stampson',
    slug: 'stampson',
    role: 'Nurture & Automation',
    description: 'Crafts the blueprints for email sequences and outreach campaigns.',
    longDescription: 'Stampson is the master strategist for nurture and automation. He designs the blueprints for complex, multi-stage email sequences that nurture your client\'s leads into customers. He provides the strategic framework for optimizing subject lines and body copy to ensure messages land in the primary inbox.',
    color: 'red',
    bgColorClass: 'bg-red-600',
    icon: FiMail,
    image: '/Stampson.webp',
    action: 'Drafted your weekly newsletter',
    time: '7:00 AM',
    faqs: [
      {
        question: "Does Stampson write the emails himself?",
        answer: "Yes. Stampson uses advanced LLMs trained on your specific brand voice and successful cold outreach templates. He writes unique, personalized copy for every recipient."
      },
      {
        question: "Can I review emails before they are sent?",
        answer: "Of course. In 'Co-Pilot' mode, Stampson drafts the emails and queues them for your approval. Once you trust him, you can switch to 'Autopilot'."
      },
      {
        question: "How does he handle spam filters?",
        answer: "Stampson monitors sender reputation and uses 'warm-up' protocols. He also varies sending times and subject lines to mimic human behavior and avoid spam traps."
      }
    ]
  },
  {
    name: 'Jeeves',
    slug: 'jeeves',
    role: 'Chief of Staff',
    description: 'Orchestrates the AI team to generate cohesive 30-50 page marketing strategy documents.',
    longDescription: 'Jeeves is the master strategist that coordinates the AI team. He aligns your client\'s business goals with the output of all other specialized gnomes, ensuring that the final strategy document is cohesive, actionable, and tailored strictly to their brand\'s unique market position.',
    color: 'orange',
    bgColorClass: 'bg-orange-600',
    icon: FiCoffee,
    image: '/Jeeves.webp',
    action: 'Coordinated daily briefing',
    time: '8:00 AM',
    faqs: [
      {
        question: "How does Jeeves coordinate the other gnomes?",
        answer: "Jeeves acts as the central router. If Gnomepoleon creates a strategy requiring ads, Jeeves automatically tasks Benjamin to create the campaigns and Kestrel to design the assets."
      },
      {
        question: "Is my business data secure with Jeeves?",
        answer: "Security is our top priority. Jeeves operates within a siloed environment for your workspace. Your strategic data is never shared with other users or used to train public models."
      },
      {
        question: "Can Jeeves schedule meetings for me?",
        answer: "Yes. Jeeves integrates with your Google Calendar or Outlook. He can negotiate times with prospects via email and book slots directly."
      }
    ]
  },
  {
    name: 'Gnomepoleon',
    slug: 'gnomepoleon',
    role: 'Strategy',
    description: 'Generates strategic roadmaps and competitive positioning documents.',
    longDescription: 'Gnomepoleon is the strategic visionary. He analyzes market trends, competitor moves, and internal performance data to map out the path to growth for your clients. From identifying blue-ocean opportunities to refining the unique value proposition, Gnomepoleon ensures every strategic move is aligned with long-term business objectives.',
    color: 'yellow',
    bgColorClass: 'bg-yellow-500',
    icon: FiMap,
    image: '/Gnomepoleon.webp',
    action: 'Updated Q3 Growth Strategy',
    time: '9:00 AM',
    faqs: [
      {
        question: "What data does Gnomepoleon analyze?",
        answer: "He ingests data from your connected analytics tools (GA4, Mixpanel), competitor websites, public financial reports, and social listening trends to form a holistic market view."
      },
      {
        question: "How often are strategies updated?",
        answer: "Gnomepoleon runs a 'Pulse Check' every morning. If he detects a significant market shift or a competitor move, he will alert you and propose a strategy adjustment immediately."
      },
      {
        question: "Can he help with pricing strategy?",
        answer: "Yes. Gnomepoleon can analyze competitor pricing models and your cost structure to recommend optimal pricing tiers for maximum profitability."
      }
    ]
  },
  {
    name: 'Gnorm',
    slug: 'gnorm',
    role: 'Community',
    description: 'Designs community engagement strategies and social channel planning documents.',
    longDescription: 'Gnorm is the community strategist. He maps out the plan for monitoring social channels, forums, and communities to engage with the audience. By providing strategies for answering questions, celebrating user wins, and fostering conversation, Gnorm helps turn passive followers into loyal brand advocates for your clients.',
    color: 'green',
    bgColorClass: 'bg-green-600',
    icon: FiShare2,
    image: '/Gnorm.webp',
    action: 'Replied to 42 comments',
    time: '11:00 AM',
    faqs: [
      {
        question: "Which platforms does Gnorm support?",
        answer: "Gnorm currently integrates with Twitter (X), LinkedIn, Facebook Groups, Reddit, and Discord. Instagram support is coming soon."
      },
      {
        question: "How does he know what to say?",
        answer: "Gnorm is trained on your brand guidelines, FAQs, and past successful interactions. You can also set specific 'Safe Mode' constraints to prevent risky topics."
      },
      {
        question: "Does Gnorm handle customer support tickets?",
        answer: "Gnorm handles public engagement. For specific support tickets, he can route issues to your helpdesk or tag a human team member for complex resolution."
      }
    ]
  },
  {
    name: 'Benjamin',
    slug: 'benjamin',
    role: 'Promotion',
    description: 'Develops paid media strategy briefs and budget allocation plans.',
    longDescription: 'Benjamin is the promotion strategist. He designs the paid advertising strategies across Facebook, Google, and LinkedIn. By outlining plans for testing ad creatives, audiences, and bid strategies, Benjamin provides the blueprint to maximize ROAS and ensure the brand reaches the right people at the right time.',
    color: 'blue',
    bgColorClass: 'bg-blue-600',
    icon: BsMegaphone,
    image: '/Benjamin.webp',
    action: 'Launched 5 new ad variations',
    time: '1:00 PM',
    faqs: [
      {
        question: "Can Benjamin manage my ad budget?",
        answer: "Yes. You set a monthly or daily cap, and Benjamin allocates spend dynamically across the best-performing channels and campaigns to maximize ROI."
      },
      {
        question: "Does he create the ad visuals?",
        answer: "Benjamin collaborates with Kestrel (Brand Gnome) to generate the visuals, while he focuses on the ad copy, targeting, and bidding strategy."
      },
      {
        question: "What platforms are supported?",
        answer: "Currently, Benjamin supports Meta Ads (Facebook/Instagram), Google Ads (Search & Display), and LinkedIn Ads."
      }
    ]
  },
  {
    name: 'Kestrel',
    slug: 'kestrel',
    role: 'Brand',
    description: 'Generates comprehensive brand guidelines and visual identity blueprints.',
    longDescription: 'Kestrel is the visual identity strategist. She creates the strategic guidelines for stunning graphics, selects the perfect imagery themes, and ensures consistent branding across all touchpoints. Kestrel makes sure your client\'s brand strategy looks professional, polished, and unforgettable.',
    color: 'purple',
    bgColorClass: 'bg-purple-600',
    icon: FaPaintBrush,
    image: '/Kestrel.webp',
    action: 'Refreshed social media assets',
    time: '3:00 PM',
    faqs: [
      {
        question: "Can Kestrel edit videos?",
        answer: "Kestrel creates static images and simple motion graphics (GIFs/MP4s) for social media. Full video editing capabilities are on the roadmap."
      },
      {
        question: "How does she know my brand colors?",
        answer: "During onboarding, you upload your brand kit (Logo, Hex Codes, Fonts). Kestrel applies these strict style guidelines to every asset she generates."
      },
      {
        question: "Can I download the source files?",
        answer: "Yes. Kestrel provides high-resolution PNG, JPG, and occasionally SVG exports for all created assets."
      }
    ]
  }
];
